/**
 * @generated SignedSource<<24044f9a5b65da11bf52027cfc29f319>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type RelatedPosts_post$data = {
  readonly related_posts: {
    readonly items: ReadonlyArray<{
      readonly slug: string
      readonly image: {
        readonly url: string
        readonly alt: string | null
      } | null
      readonly h1: string
    }>
  }
  readonly ' $fragmentType': 'RelatedPosts_post'
}
export type RelatedPosts_post$key = {
  readonly ' $data'?: RelatedPosts_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'RelatedPosts_post'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'RelatedPosts_post',
  selections: [
    {
      alias: null,
      args: [
        {
          kind: 'Literal',
          name: 'page',
          value: {
            from: 0,
            size: 20
          }
        }
      ],
      concreteType: 'PostResult',
      kind: 'LinkedField',
      name: 'related_posts',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          concreteType: 'Post',
          kind: 'LinkedField',
          name: 'items',
          plural: true,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'slug',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              concreteType: 'PostImage',
              kind: 'LinkedField',
              name: 'image',
              plural: false,
              selections: [
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'url',
                  storageKey: null
                },
                {
                  alias: null,
                  args: null,
                  kind: 'ScalarField',
                  name: 'alt',
                  storageKey: null
                }
              ],
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'h1',
              storageKey: null
            }
          ],
          storageKey: null
        }
      ],
      storageKey: 'related_posts(page:{"from":0,"size":20})'
    }
  ],
  type: 'Post',
  abstractKey: null
}

;(node as any).hash = 'b805760975a6ffb5f59321b00410ae0a'

export default node
